<nice-layout
    class="bg-public-image relative flex h-dvh w-screen overflow-y-auto bg-cover bg-no-repeat p-4 sm:p-8 xl:bg-none"
>
    <div class="absolute left-0 top-0 z-10 h-full w-full bg-primary/40 xl:hidden"></div>
    <section class="z-20 my-auto flex w-full justify-center xl:basis-2/5">
        <div
            class="bg-white-to-gray box-content flex w-100 max-w-11/12 flex-col items-center justify-center gap-6 rounded-3xl px-5 py-12 sm:gap-16 sm:px-12 xl:bg-none"
        >
            <div class="flex select-none flex-col">
                <img [src]="organisationLogo" />
                <div class="flex items-end justify-end gap-3">
                    <div class="lowercase">{{ "features.root.powered_by" | translate }}</div>
                    <img class="w-28" src="assets/images/logo-municipal.svg" />
                </div>
            </div>

            <ng-content />
        </div>
    </section>

    <section class="relative z-20 hidden xl:flex xl:basis-3/5">
        <img class="w-full rounded-xl object-cover" src="assets/images/default_background.jpg" />
        <div class="absolute h-full w-full rounded-xl bg-primary/40">
            <div
                class="flex h-full items-center px-36 text-6xl font-extrabold leading-snug text-white"
                [innerHTML]="'features.register.simplify_management' | translate"
            ></div>
        </div>
    </section>
</nice-layout>
